import React from "react";
import { H3 } from "../../ui/Typography";
import "./Showcase.scss";
import {
  Button,
  ButtonWithIcon,
  ButtonWithTextIcon,
  TextButton,
} from "../../ui";
import { DownloadIcon, Info } from "../../ui/icons";

function ShowcaseButtons() {
  return (
    <>
      <div className="showcase-wrapper">
        <H3>(CTA-1.1) Outline Button, 2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-h28px</th>
                <th>M-h36px</th>
                <th>L-h44px</th>
                <th>XL-h54px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Button size="sm" variant="primary">
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="md" variant="primary">
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="lg" variant="primary">
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="xl" variant="primary">
                    Download
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <Button size="sm" variant="primary" disabled>
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="md" variant="primary" disabled>
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="lg" variant="primary" disabled>
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="xl" variant="primary" disabled>
                    Download
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-1.2) Outline Button with icon, 2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-h28px</th>
                <th>M-h36px</th>
                <th>L-h44px</th>
                <th>XL-h54px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <ButtonWithTextIcon
                    size="sm"
                    variant="primary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="md"
                    variant="primary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="lg"
                    variant="primary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="xl"
                    variant="primary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <ButtonWithTextIcon
                    size="sm"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="md"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="lg"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="xl"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-1.3) Floating Button 2px Outline</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-h28px</th>
                <th>M-h36px</th>
                <th>L-h44px</th>
                <th>XL-h54px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <ButtonWithIcon
                    size="sm"
                    variant="primary"
                    icon={DownloadIcon}
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="md"
                    variant="primary"
                    icon={DownloadIcon}
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="lg"
                    variant="primary"
                    icon={DownloadIcon}
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="xl"
                    variant="primary"
                    icon={DownloadIcon}
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <ButtonWithIcon
                    size="sm"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="md"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="lg"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="xl"
                    variant="primary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="showcase-wrapper">
        <H3>(CTA-2.1) Outline Button, 2px Outline (hover fill)</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-h28px</th>
                <th>M-h36px</th>
                <th>L-h44px</th>
                <th>XL-h54px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Button size="sm" variant="secondary">
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="md" variant="secondary">
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="lg" variant="secondary">
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="xl" variant="secondary">
                    Download
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <Button size="sm" variant="secondary" disabled>
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="md" variant="secondary" disabled>
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="lg" variant="secondary" disabled>
                    Download
                  </Button>
                </td>
                <td>
                  <Button size="xl" variant="secondary" disabled>
                    Download
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-2.2) Outline Button with icon, 2px Outline (hover fill)</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-h28px</th>
                <th>M-h36px</th>
                <th>L-h44px</th>
                <th>XL-h54px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <ButtonWithTextIcon
                    size="sm"
                    variant="secondary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="md"
                    variant="secondary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="lg"
                    variant="secondary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="xl"
                    variant="secondary"
                    icon={DownloadIcon}
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <ButtonWithTextIcon
                    size="sm"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="md"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="lg"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
                <td>
                  <ButtonWithTextIcon
                    size="xl"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  >
                    Download
                  </ButtonWithTextIcon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-2.3) Floating Button 2px Outline (hover fill) </H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-h28px</th>
                <th>M-h36px</th>
                <th>L-h44px</th>
                <th>XL-h54px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <ButtonWithIcon
                    size="sm"
                    variant="secondary"
                    icon={DownloadIcon}
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="md"
                    variant="secondary"
                    icon={DownloadIcon}
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="lg"
                    variant="secondary"
                    icon={DownloadIcon}
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="xl"
                    variant="secondary"
                    icon={DownloadIcon}
                  />
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <ButtonWithIcon
                    size="sm"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="md"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="lg"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
                <td>
                  <ButtonWithIcon
                    size="xl"
                    variant="secondary"
                    icon={DownloadIcon}
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="showcase-wrapper">
        <H3>(CTA-3.1) Text Button</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-txt 12</th>
                <th>M-txt 16</th>
                <th>L-txt 20</th>
                <th>XL-txt 24</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TextButton size="sm" variant="primary">
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="md" variant="primary">
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="lg" variant="primary">
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="xl" variant="primary">
                    Help
                  </TextButton>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TextButton size="sm" variant="primary" disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="md" variant="primary" disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="lg" variant="primary" disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="xl" variant="primary" disabled>
                    Help
                  </TextButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-3.2) Underlined Text Button</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-txt 12</th>
                <th>M-txt 16</th>
                <th>L-txt 20</th>
                <th>XL-txt 24</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TextButton size="sm" variant="secondary">
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="md" variant="secondary">
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="lg" variant="secondary">
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="xl" variant="secondary">
                    Help
                  </TextButton>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TextButton size="sm" variant="secondary" disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="md" variant="secondary" disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="lg" variant="secondary" disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="xl" variant="secondary" disabled>
                    Help
                  </TextButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-3.3) Text Button with Icon</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-txt 12</th>
                <th>M-txt 16</th>
                <th>L-txt 20</th>
                <th>XL-txt 24</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TextButton size="sm" variant="primary" icon={Info}>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="md" variant="primary" icon={Info}>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="lg" variant="primary" icon={Info}>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="xl" variant="primary" icon={Info}>
                    Help
                  </TextButton>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TextButton size="sm" variant="primary" icon={Info} disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="md" variant="primary" icon={Info} disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="lg" variant="primary" icon={Info} disabled>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="xl" variant="primary" icon={Info} disabled>
                    Help
                  </TextButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-3.4) Underlined Text Button with Icon</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-txt 12</th>
                <th>M-txt 16</th>
                <th>L-txt 20</th>
                <th>XL-txt 24</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TextButton size="sm" variant="secondary" icon={Info}>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="md" variant="secondary" icon={Info}>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="lg" variant="secondary" icon={Info}>
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton size="xl" variant="secondary" icon={Info}>
                    Help
                  </TextButton>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TextButton
                    size="sm"
                    variant="secondary"
                    icon={Info}
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="md"
                    variant="secondary"
                    icon={Info}
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="lg"
                    variant="secondary"
                    icon={Info}
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="xl"
                    variant="secondary"
                    icon={Info}
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>(CTA-3.5) Text Button with Icon 2</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>S-txt 12</th>
                <th>M-txt 16</th>
                <th>L-txt 20</th>
                <th>XL-txt 24</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <TextButton
                    size="sm"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="md"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="lg"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="xl"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                  >
                    Help
                  </TextButton>
                </td>
              </tr>
              <tr>
                <th>Disabled</th>
                <td>
                  <TextButton
                    size="sm"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="md"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="lg"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
                <td>
                  <TextButton
                    size="xl"
                    variant="primary"
                    icon={Info}
                    iconVariant="secondary"
                    disabled
                  >
                    Help
                  </TextButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShowcaseButtons;
